import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/link.png';
import _imports_1 from '@/assets/imgs/add_icon.png';

const _withScopeId = n => (_pushScopeId("data-v-47334e99"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "brands__card"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "sub-main"
};
const _hoisted_4 = {
  class: "sub__title"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "info-warp"
};
const _hoisted_7 = {
  class: "logo"
};
const _hoisted_8 = {
  class: "main"
};
const _hoisted_9 = {
  class: "name"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  class: "footer"
};
const _hoisted_12 = ["onClick"];

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "add-inner pointer"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "add__img",
  src: _imports_1,
  alt: ""
}), /*#__PURE__*/_createElementVNode("footer", {
  class: "text--center"
}, "Add")], -1));

const _hoisted_14 = [_hoisted_13];
import { getTextWidth } from '@/utils';
import { ref } from 'vue';
import { useCommon } from '@/store/useCommon';
import { intersect } from '@/utils/tools';
import MyLoadingImage from '@/components/MyLoadingImage/index.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    data: {
      type: Array,
      default: []
    },
    currentSelectKey: {
      type: String,
      default: 'id'
    },
    currentSelectValue: {
      type: [String, Number],
      default: -1
    }
  },
  emits: ['handleAdd', 'handleCommand', 'itemClick', 'moduleItemClick', 'handleDisassociate', 'showCreateSubBrandDialog'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const ownPermission = computed(() => {
      return useCommon().userData.permissionKey || [];
    }); // 悬浮下拉权限列表

    const dropdownPermissionList = ref(['OP_PO_ES', 'OP_PO_CS', 'OP_PO_RS', 'OP_PO_DS']);
    const isShowMoreDropdown = computed(() => {
      return intersect(dropdownPermissionList.value, useCommon().userData.permissionKey);
    });
    const statusObj = reactive({
      0: {
        color: '#929BA5',
        class: 'stop-bg'
      },
      1: {
        color: '#56D286',
        class: 'running-bg'
      },
      2: {
        color: '#F5AE32',
        class: 'checking-bg'
      }
    });

    const handleAdd = type => {
      emits('handleAdd', type);
    };

    const showCreateSubBrandDialog = () => {
      emits('showCreateSubBrandDialog');
    }; // 子品牌编辑删除触发子传父


    const handleCommand = (item, type) => {
      emits('handleCommand', {
        type,
        data: item
      });
    };

    const moduleItemClick = (item, moduleList) => {
      if (item.name === 'MyLink') return false;
      const findItem = moduleList.find(f => f == 'VOD');
      emits('moduleItemClick', { ...item,
        VodCategoryId: findItem ? findItem.categoryId : ''
      });
    };

    const stopClick = () => {}; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText, {
        fontSize: '14px'
      });
      tipDisabled.value = target.offsetWidth < width;
    };

    const itemClick = (item, index) => {
      emits('itemClick', item, index);
    };

    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      const _component_MPopper = _resolveComponent("MPopper");

      return _openBlock(), _createElementBlock("ul", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          onClick: _withModifiers($event => itemClick(item, index), ["stop"]),
          class: _normalizeClass(statusObj[item.status].class)
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
          style: _normalizeStyle(`visibility:${item.relationSubAgentId ? '' : 'hidden'}`),
          src: _imports_0,
          alt: ""
        }, null, 4), _unref(isShowMoreDropdown) ? (_openBlock(), _createBlock(_component_el_dropdown, {
          key: 0,
          "show-timeout": 100,
          onClick: _withModifiers(stopClick, ["stop"]),
          onCommand: $event => handleCommand(item, $event)
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [_unref(ownPermission).includes('OP_PO_ES') ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
              key: 0,
              command: "edit"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('编辑')), 1)]),
              _: 1
            })) : _createCommentVNode("", true), item.relationSubAgentId && _unref(ownPermission).includes('OP_PO_RS') ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
              key: 1,
              command: "disassociate"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('解除关联')), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _unref(ownPermission).includes('OP_PO_DS') ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
              key: 2,
              command: "delete"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('删除')), 1)]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 2
          }, 1024)]),
          default: _withCtx(() => [_createElementVNode("i", {
            onClick: _withModifiers(stopClick, ["stop"]),
            class: "iconfont icon-gengduo fs--26 more__setting"
          }, null, 8, _hoisted_5)]),
          _: 2
        }, 1032, ["onClick", "onCommand"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [item.logo ? (_openBlock(), _createBlock(MyLoadingImage, {
          key: 0,
          style: {
            "border-radius": "15px"
          },
          src: item.logo
        }, null, 8, ["src"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('名称')) + ":", 1), _createVNode(_component_MPopper, {
          disabled: tipDisabled.value,
          placement: "top",
          trigger: "hover",
          content: item.name
        }, {
          reference: _withCtx(() => [_createElementVNode("span", {
            onMouseover: showTextTip,
            class: "name"
          }, _toDisplayString(item.name), 33)]),
          _: 2
        }, 1032, ["disabled", "content"])]), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('状态')) + ":", 1), _createVNode(_component_MPopper, {
          disabled: tipDisabled.value,
          placement: "top",
          trigger: "hover",
          content: item.status === 1 ? _ctx.$t('运行') : item.status === 2 ? _ctx.$t('终端审核') : _ctx.$t('停运')
        }, {
          reference: _withCtx(() => [_createElementVNode("span", {
            style: _normalizeStyle(`color: ${item && statusObj[item.status].color}`),
            onMouseover: showTextTip,
            class: "status"
          }, _toDisplayString(item.status === 1 ? _ctx.$t('运行') : item.status === 2 ? _ctx.$t('终端审核') : _ctx.$t('停运')), 37)]),
          _: 2
        }, 1032, ["disabled", "content"])]), item.relationSubAgentName ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('关联同步')) + ":", 1), _createVNode(_component_MPopper, {
          disabled: tipDisabled.value,
          placement: "top",
          trigger: "hover",
          content: item.relationSubAgentName
        }, {
          reference: _withCtx(() => [_createElementVNode("span", {
            onMouseover: showTextTip,
            class: "item-name"
          }, _toDisplayString(item.relationSubAgentName || _ctx.$t('无')), 33)]),
          _: 2
        }, 1032, ["disabled", "content"])])) : _createCommentVNode("", true)])]), _createElementVNode("footer", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.operationModules || [], (moduleItem, moduleIndex) => {
          return _openBlock(), _createElementBlock("span", {
            onClick: $event => moduleItemClick({
              moduleItem,
              subId: item.id,
              ...item
            }, item.operationModules),
            key: moduleIndex,
            class: _normalizeClass([moduleItem === 'MyLink' ? 'disabled' : ''])
          }, _toDisplayString(moduleItem), 11, _hoisted_12);
        }), 128))])])], 10, _hoisted_2);
      }), 256)), _unref(ownPermission).includes('OP_PO_SC') ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        class: "add__item",
        onClick: showCreateSubBrandDialog
      }, _hoisted_14)) : _createCommentVNode("", true)]);
    };
  }

});